import React from 'react';
import useStyle from './bottomMenuLegend.style';
import { Divider } from 'components/atoms/Dividers/Divider';

interface BottomMenuLegendProps {
  items: string[];
}

export const BottomMenuLegend = ({ items }: BottomMenuLegendProps) => {
  const classes = useStyle();

  return (
    <div className={classes.root}>
      {items.map((item, key) => (
        <div key={key} className={classes.item}>
          <span>{item}</span>
          <Divider isBottomMenu={true} direction="vertical" />
        </div>
      ))}
    </div>
  );
};
